import { FC } from 'react';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useStyles } from './styles';

function createData(id: number, dateAndTime: string, adminUserId: string, description: string) {
  return { id, dateAndTime, adminUserId, description };
}

const rows = [
  createData(0, '16.03.2019 | 12:32', 'bill.sanders@example.com', 'Logged In'),
  createData(1, '16.03.2019 | 12:32', 'felicia.reid@example.com', 'Logged Out'),
  createData(2, '16.03.2019 | 12:32', 'kenzi.lawson@example.com', 'Expired Licence'),
  createData(3, '16.03.2019 | 12:32', 'jessica.hanson@example.com', 'Logged In'),
  createData(4, '16.03.2019 | 12:32', 'debra.holt@example.com', 'Logged Out'),
];

export const TranzactionAndErrorLogs: FC = () => {
  const classes = useStyles();
  return (
    <>
      <Table className={classes.table} aria-label='caption table'>
        <TableHead>
          <TableRow className={classes.tableHead}>
            <TableCell>Date and time</TableCell>
            <TableCell>Admin user Id</TableCell>
            <TableCell>Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.dateAndTime}</TableCell>
              <TableCell>
                <Button color='secondary' className={classes.link}>
                  {row.adminUserId}
                </Button>
              </TableCell>
              <TableCell>{row.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className={classes.btnBox}>
        <Button variant='contained' color='secondary' className={classes.btn}>
          Show All
        </Button>
      </div>
    </>
  );
};
